import React from "react";
import { Link } from "react-router-dom";
import { brand, social } from "@/config/site";
import { InstagramIcon, TikTokIcon, FacebookIcon } from "@/components/SocialIcons";

const footerNav = [
  { label: "Home", to: "/" },
  { label: "Books", to: "/books" },
  { label: "About Dhamma", to: "/about-dhamma" },
  { label: "About Bugg", to: "/about-bugg" },
  { label: "Contact", to: "/contact" },
  { label: "ARC Team", to: "/arc" },
  { label: "Privacy", to: "/privacy" },
];

const socials = [
  { name: "Instagram", href: social.instagram, Icon: InstagramIcon },
  { name: "TikTok", href: social.tiktok, Icon: TikTokIcon },
  { name: "Facebook", href: social.facebook, Icon: FacebookIcon },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-dh-cream/10 bg-dh-bg2">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 pt-20 pb-10">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-3" aria-label="Dhamma home">
              <img src={brand.logoMark} alt="Dhamma Publishing House logo" className="h-16 w-16 object-contain" />
              <span className="flex flex-col leading-none">
                <span className="font-display text-xl text-dh-cream">Dhamma Publishing House</span>
                <span className="mt-1 font-body text-[10px] uppercase tracking-ultra text-dh-gold/80">
                  {brand.tagline}
                </span>
              </span>
            </Link>
          </div>

          <nav className="md:col-span-4" aria-label="Footer">
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {footerNav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="font-body text-sm text-dh-muted transition-colors duration-300 hover:text-dh-cream"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-3">
            <p className="font-body text-[10px] uppercase tracking-ultra text-dh-muted">Connect</p>
            <div className="mt-4 flex items-center gap-3">
              {socials.map(({ name, href, Icon }) => (
                <a
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={name}
                  data-testid={`footer-social-${name.toLowerCase()}`}
                  className="inline-flex h-11 w-11 items-center justify-center border border-dh-cream/15 text-dh-cream/70 transition-all duration-500 hover:border-dh-gold hover:text-dh-gold"
                >
                  <Icon />
                </a>
              ))}
            </div>
            <a
              href={`mailto:${brand.contactEmail}`}
              className="mt-5 inline-block font-body text-sm text-dh-muted transition-colors hover:text-dh-cream"
            >
              {brand.contactEmail}
            </a>
          </div>
        </div>

        <div className="gold-rule my-12" />

        {/* Oversized typographic mark */}
        <div className="overflow-hidden">
          <p className="select-none font-display text-[15vw] leading-[0.8] text-dh-cream/5 md:text-[11vw]">
            Dhamma
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-body text-xs text-dh-muted">{brand.legalName}</p>
          <p className="font-body text-xs text-dh-muted">{brand.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
